export default {
  subtitle: "Select <b class='text-info'>Work Order</b> for <b class='text-info'>{entity}</b>",
  restriction: "Restricted to applicable <b class='text-info'>Work Domains</b>",
}
